import React, {useEffect, useState} from "react";
import bg from "../assets/bg.jpg"
import {useNavigate} from "react-router-dom";
import axios from "axios";
import logo from "../assets/logo.png"
import _ from "lodash"
import {Input, Modal} from "@arco-design/web-react";

function Home() {

    const navigate = useNavigate();
    // const [images, setImages] = useState([]);
    const [visible, setVisible] = React.useState(false);
    const [inputKey,setInputKey] = React.useState('');

    useEffect(() => {
        // // 在组件加载时发送HTTP请求获取图片数据
        // axios.get('http://127.0.0.1:5000/get_images')
        //     .then(response => {
        //         setImages(response.data);
        //     })
        //     .catch(error => {
        //         console.error('Error fetching images:', error);
        //     });
        const test=localStorage.getItem("count_chat");
        if(test && JSON.parse(test)?.[38]===undefined){
            localStorage.clear();
            console.log("redefine")
        }
        if(!localStorage.getItem('count_like') || !localStorage.getItem('count_rank')  || !localStorage.getItem('count_chat') ){
            const count_like ={}
            const count_rank ={}
            const count_chat ={}
            for (let i = 0; i <= 50; i++) {
                count_like[i] = [0,0]; //like,dislike
                count_rank[i] = [0,0]; //score,cnt
                count_chat[i] = 0;
            }
            localStorage.setItem('count_like', JSON.stringify(count_like));
            localStorage.setItem('count_rank', JSON.stringify(count_rank));
            localStorage.setItem('count_chat', JSON.stringify(count_chat));
        }
    }, []);

    return (
        <div className="home">
            <div className="home-left">
                <div className="home-header" style={{cursor:'pointer'}} onClick={() => navigate('/carboncopydating')}>
                    <img src={logo} width={45} height={45} style={{marginRight:20}} onClick={()=>navigate('/carboncopydating')}/>
                    carbon copy
                </div>
                <div className="home-login-card" style={{display:"flex",flexWrap:"wrap",justifyContent:"center"}}>
                    <div className="home-title-1">
                        Find your carbon copy
                    </div>
                    {/*<div className="home-title-2">*/}
                    {/*    Follow your intuition */}
                    {/*</div>*/}
                    <div className="home-title-3">
                        By clicking Join, you agree to our Terms. Learn how we process your data in our Privacy and Cookies Policy.
                    </div>
                    <Modal
                        title='API KEY'
                        visible={visible}
                        okText={'OK'}
                        cancelText={"Cancel"}
                        onOk={() => {
                            localStorage.setItem('api_key', inputKey);
                            setVisible(false)}}
                        onCancel={() => setVisible(false)}
                        autoFocus={false}
                        focusLock={true}
                    >
                        <Input value={inputKey} onChange={(newkey)=>{setInputKey(newkey)}}/>
                    </Modal>
                    <button style={{width:"100%"}} className="buttom-pink" onClick={()=>{navigate(`/carboncopydating/person/31`)}}>Enter</button>

                    <div className="home-title-3" style={{color: '#a4a4a4',cursor:'pointer'}}
                         onClick={() => setVisible(true)}>
                        Change relevant API configurations.
                    </div>
                </div>
            </div>
            <div className="home-right" style={{justifyContent:"center"}}>
                <div style={{display:"flex",justifyContent:"center"}}>
                    {/*{images?.map((image, id) => (*/}
                    {/*    <div className="grid-item" key={id}>*/}
                    {/*        <img src={image} alt={`Image ${id}`} />*/}
                    {/*    </div>*/}
                    {/*))}*/}
                    <img src={bg} style={{width:"90%"}} />
                </div>
            </div>
        </div>
    );
}

export default Home;
